import React, { useEffect, useCallback } from "react";
import renderSelectField from "../../shared/components/form/Select";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { getSCPIssuers } from "./actions/issuer.actions";
import { Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";

const SCPIssuersDropDown = ({
  scpIssuers,
  label,
  dispatch,
  disabled,
  onChange,
  id,
  required,
  isScpLite
}) => {
  const handleGetSCPIssuers = useCallback(() => {
    dispatch(getSCPIssuers(isScpLite));
  }, [dispatch]);

  useEffect(() => {
  
    handleGetSCPIssuers();
  }, [handleGetSCPIssuers]);

  return (
    <div className="form__form-group">
      <span className={`form__form-group-label ${required ? "required" : ""}`}>
        {label}
      </span>
      <div className="form__form-group-field">
        <Field
          id={id}
          name="scpIssuers"
          customChange={onChange}
          component={renderSelectField}
          options={(scpIssuers.response && scpIssuers.response.data) || []}
          valueKey="issuerCode"
          disabled={disabled}
          labelKey="issuerName"
        />
      </div>
      {scpIssuers && scpIssuers.error ? (
        <Alert color="danger">
          Could not fetch issuers
          {scpIssuers.loading ? (
            <Spinner className="float-right" size="sm" color="danger" />
          ) : (
            <MdRefresh
              onClick={handleGetSCPIssuers}
              className="float-right pointer"
              size={20}
            />
          )}
        </Alert>
      ) : null}
    </div>
  );
};

export default connect(state => ({
  scpIssuers: state.scpIssuers
}))(SCPIssuersDropDown);
